import script from "./ApiDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiDoc.vue?vue&type=script&setup=true&lang=js"

import "./ApiDoc.vue?vue&type=style&index=0&id=034cbeee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034cbeee"]])

export default __exports__